import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import {
  DownloadAppModalComponent,
  MobileDetectService,
  RouterService,
  ShareModalService,
  UserModel,
  UserService,
} from '@lib/gc-common';
import { environment } from '@libs/gc-common/environments/environment';

@Component({
  selector: 'mip-profile-user-actions',
  templateUrl: './profile-user-actions.component.html',
  styleUrls: ['./profile-user-actions.component.scss'],
})
export class ProfileUserActionsComponent implements OnInit {
  @Input() profile: UserModel = null;

  moreOptionsList = [
    /*{
	 text: 'Settings',
	 path: 'edit'
	 }, {
	 text: 'Notifications',
	 path: 'notifications'
	 }, {
	 text: 'Replicas',
	 path: 'replicas'
	 }, {
	 text: 'About',
	 path: 'about'
	 }, {
	 text: 'Support',
	 path: 'support'
	 },*/ {
      text: 'Logout',
      path: 'logout',
      onSelect: this.onLogout.bind(this),
    },
  ];

  isMobile = true;
  isDesktop = false;

  profileLanguages: {
    content_language: Array<string> | string;
    application_language: string;
  };

  constructor(
    private bottomSheet: MatBottomSheet,
    private userService: UserService,
    private routerService: RouterService,
    private shareModalService: ShareModalService,
    private mobileDetectService: MobileDetectService,
  ) {
    // console.log('profile-user-actions.component->constructor(): this.userService', this.userService);

    this.isMobile = this.mobileDetectService.isMobile();
    this.isDesktop = !this.mobileDetectService.isMobile();
  }

  ngOnInit(): void {
    this.profileLanguages = this.profile.getLanguages();
  }

  openDownloadAppDialog() {
    if (this.profile && this.profile.isAuthenticated) {
      this.bottomSheet.open(DownloadAppModalComponent);
    } else {
      this.routerService.navigateTo(environment.loginUrl);
    }
  }

  onLogout() {
    // console.log('profile-user-actions.component->onLogout()');
    this.userService.logout();
  }

  /*shareProfile() {
	 this.shareModalService.shareOpen({
	 url: window.location.href,
	 imageLeft: this.profile.getAvatarSource()
	 });
	 }*/

  get checkLanguageIsPt() {
    return (
      this.profileLanguages.application_language === 'pt' ||
      this.profileLanguages.content_language === 'pt' ||
      this.profileLanguages.content_language.includes('pt')
    );
  }
}
